import MacleJSBridge from 'src/bridges';
import { APINames } from 'src/shared';
import { GeneralInvokeOption } from 'src/types';

// 获取用户公开信息
export function getOpenUserInfo(option?: GeneralInvokeOption) {
  return MacleJSBridge.beforeInvoke(APINames.Native.GET_OPEN_USER_INFO, option);
}
